import { toPositiveInt } from '@/utils/numberValue';

export const resolveTotalPages = (totalItems, pageSize) => {
  const safeTotalItems = Math.max(0, Number(totalItems || 0));
  const safePageSize = toPositiveInt(pageSize, 1);

  if (safeTotalItems === 0) {
    return 1;
  }

  return Math.ceil(safeTotalItems / safePageSize);
};

export const ensureValidPage = (currentPage, totalPages) => {
  const safeTotalPages = toPositiveInt(totalPages, 1);
  const safeCurrentPage = toPositiveInt(currentPage, 1);

  if (safeCurrentPage > safeTotalPages) {
    return safeTotalPages;
  }

  return safeCurrentPage;
};

export const resolvePageChange = (nextPage, totalPages, currentPage = 1) => {
  const parsed = Number(nextPage);
  const safeCurrentPage = toPositiveInt(currentPage, 1);

  if (!Number.isFinite(parsed)) {
    return ensureValidPage(safeCurrentPage, totalPages);
  }

  return ensureValidPage(parsed, totalPages);
};

export const sliceRowsByPage = (rows, currentPage, pageSize) => {
  const safeRows = Array.isArray(rows) ? rows : [];
  const safePageSize = toPositiveInt(pageSize, 1);
  const safeCurrentPage = ensureValidPage(currentPage, resolveTotalPages(safeRows.length, safePageSize));

  const start = (safeCurrentPage - 1) * safePageSize;
  return safeRows.slice(start, start + safePageSize);
};

export const buildPaginationPayload = ({ currentPage, pageSize, totalItems }) => {
  const safePageSize = toPositiveInt(pageSize, 1);
  const safeTotalItems = Math.max(0, Number(totalItems || 0));
  const totalPages = resolveTotalPages(safeTotalItems, safePageSize);
  const safeCurrentPage = ensureValidPage(currentPage, totalPages);

  return {
    current_page: safeCurrentPage,
    per_page: safePageSize,
    total_pages: totalPages,
    total_items: safeTotalItems,
  };
};

export const normalizePaginationPayload = (rawPagination, fallback = {}) => {
  const raw = rawPagination && typeof rawPagination === 'object' ? rawPagination : {};

  const fallbackCurrentPage = toPositiveInt(fallback?.current_page, 1);
  const fallbackPerPage = toPositiveInt(fallback?.per_page, 20);

  const currentPage = toPositiveInt(raw.current_page, fallbackCurrentPage);
  const perPage = toPositiveInt(raw.per_page, fallbackPerPage);
  const totalItems = Math.max(0, Number(raw.total_items ?? fallback?.total_items ?? 0));
  const fallbackTotalPages = resolveTotalPages(totalItems, perPage);
  const totalPages = toPositiveInt(raw.total_pages, toPositiveInt(fallback?.total_pages, fallbackTotalPages));

  return {
    current_page: ensureValidPage(currentPage, totalPages),
    per_page: perPage,
    total_pages: totalPages,
    total_items: totalItems,
  };
};
